<template>
  <article class="post-article"></article>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>
